import { render, staticRenderFns } from "./header_actions.vue?vue&type=template&id=e599de3a&scoped=true&"
import script from "./header_actions.vue?vue&type=script&lang=js&"
export * from "./header_actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e599de3a",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2F_snippets%2Fheader_actions%2Fheader_actions.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./header_actions.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports